import React from 'react';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './TrustStrip.module.css';

const ITEMS = [
  { Icon: EventAvailableOutlinedIcon, title: 'Cancele quando quiser', text: 'Sem fidelidade nem taxa escondida.' },
  { Icon: SaveOutlinedIcon, title: 'Seus dados ficam salvos', text: 'Agenda, cadastros e históricos continuam como estão.' },
  { Icon: LockOutlinedIcon, title: 'Pagamento seguro', text: 'Cobrança mensal processada pelo Stripe.' },
];

/** Faixa curta de confiança da página de Planos. */
const TrustStrip = () => (
  <ul className={styles.strip}>
    {ITEMS.map(({ Icon, title, text }) => (
      <li key={title} className={styles.item}>
        <span className={styles.iconWrap}><Icon className={styles.icon} /></span>
        <span className={styles.texts}>
          <strong className={styles.title}>{title}</strong>
          <span className={styles.text}>{text}</span>
        </span>
      </li>
    ))}
  </ul>
);

export default TrustStrip;
